import React, { PropTypes,  Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as toursActions from '../actions/tours';
import Map from '../components/Map';
import Header from '../components/layout/Header';
import { Link } from 'react-router';
import Helmet from "react-helmet";

class MapPage extends Component {
    shoulComponentUpdate() {
        return false;
    }

    componentWillMount() {


        this.props.toursActions.fetchActivities();
        this.props.toursActions.setScroll({scrollY: 0, opacity: 1});

       //console.info('PARAMS');
       //console.info(this.props.location.query);

        let center = false,
            mapConfig = {
                showBoundedObjects: true,
                type: 'ROADMAP',
                active: true,
                fixed: false,
                forceListBySearch: false
            };
        if (this.props.location.query.lat && this.props.location.query.lng) {
            mapConfig = {...mapConfig, center: {lat: this.props.location.query.lat, lng: this.props.location.query.lng}};
        }

        if (this.props.location.query.zoom) {
            mapConfig = {...mapConfig, zoom: this.props.location.query.zoom};
        }
        
        
        

        this.props.toursActions.setMapConfig(mapConfig);


       //console.log('MAP FILTER!!!!!!!!!!!!!!!!!!!!!!');
        /*console.log({
            t: this.props.location.query.type,
            m: this.props.location.query.months,
            d: this.props.location.query.type,
            a: this.props.location.query.type
        });*/
        /*
        this.props.toursActions.setMapFilter({
            t: this.props.location.query.type,
            m: this.props.location.query.months,
            d: this.props.location.query.type,
            a: this.props.location.query.type
        });
        */

    }

    componentWillUnmount() {

        this.props.toursActions.setMapConfig({
            showBoundedObjects: false,
            type: 'ROADMAP',
            active: false,
            listByMap: true
        });

    }

    render () {

        let {tour} = this.props;

        return (
            <div className="map__top">
                <div className="section__content section__content_controls">
                    <Header />

                    {false &&
                        <div className="container overview" ref="tourContainer">
                            <div >
                                <span className="overview__type"><span className="overview__type_required">Discovery</span>nature</span>
                                <h1>
                                    <Link
                                        to={"/tour/" + (tour.id_old?tour.id_old:tour.id)}>
                                        {tour.title}
                                        </Link>
                                </h1>


                            </div>


                        </div>
                    }
                </div>
            </div>
        );
    }
}




function mapStateToProps (state) {
    return {
        map: state.tours.map,
        tour: state.tours.tour,
        translations: state.user.translations
    }
}

function mapDispatchToProps (dispatch) {
    return {
        toursActions: bindActionCreators(toursActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MapPage)




// WEBPACK FOOTER //
// ./src/common/containers/MapPage.js